<template>
    <div class="list-calendar">
        <div
            ref="list"
            class="list-calendar__list"
            :style="{ 'padding-bottom': offsetPadding }"
        >
            <v-calendar
                ref="vcal"
                class="list-calendar__vc-calendar"
                :min-date="minDate"
                :max-date="maxDate"
                @update:to-page="monthChanged"
            >
                <template #header-title="{ monthLabel, yearLabel }">
                    <p class="list-calendar__header-title-range">
                        {{ dayRangeLabel }}
                    </p>
                    <p class="list-calendar__header-title-month">
                        {{ `${monthLabel} ${yearLabel}` }}
                    </p>
                </template>
                <template #header-left-button>
                    <i
                        class="list-calendar__header-icon fa fa-chevron-left icon"
                        aria-hidden="true"
                        @click="moveCalendar($event, 'previous')"
                    />
                </template>
                <template #header-right-button>
                    <i
                        class="list-calendar__header-icon fa fa-chevron-right icon"
                        aria-hidden="true"
                        @click="moveCalendar($event, 'next')"
                    />
                </template>
            </v-calendar>
            <ul>
                <li
                    :key="i"
                    v-for="(resource, i) in resources"
                    v-show="filteredResourceExtras[resource[0].id] && filteredResourceExtras[resource[0].id].length > 0 && onlyActiveVisible(resource)"
                    class="list-calendar__list-item"
                    :style="{ height: calculatedHeight[resource[0].id] }"
                >
                    <p class="list-calendar__list-item-cell">
                        <span
                            class="list-calendar__list-item-link"
                            @click="toggleExtras(resource[0].id)"
                        >
                            <i
                                v-if="filteredResourceExtras[resource[0].id] && filteredResourceExtras[resource[0].id].length > 0"
                                class="list-calendar__icon fa fa-chevron-right icon is-small"
                                :class="{ 'fa-rotate-90': calculatedHeight[resource[0].id] !== heightPerLineString }"
                                aria-hidden="true"
                            />
                            {{ resource[0].name }}
                        </span>

                        <i
                            v-if="'active' in resource[0] && resource[0].active !== true"
                            class="fa fa-lock fa-lg"
                            title="No active accommodation type"
                            style="padding-right: 1rem; color: red"
                        ></i>

                            <i
                                v-if="resource[0] && resource[0].pricelist_range && resource[0].pricelist_range.show_warning"
                                class="fa fa-warning fa-lg"
                                style="padding-right: 1rem; color:#ff9800;"
                                :title="'Es gibt nur noch eine Preisliste für ' + resource[0].pricelist_range.days_from_now +' Tage'"
                                @click="showAdditionalInfo(resource, resource[0])"
                            />

                        <i
                            class="fa fa-info-circle fa-lg pointer"
                           style="padding-right: 1rem"
                           @click="showAdditionalInfo(resource, resource[0])"/>


                        <i
                            class="list-calendar__icon fa fa-pencil-square-o fa-lg"
                            aria-hidden="true"
                            @click="setResource(resource)"
                        />
                    </p>

                    <ul class="list-calendar__list-item-extras">
                        <li
                            :key="`extra-${extra.name}`"
                            v-for="extra in filteredResourceExtras[resource[0].id]"
                            class="list-calendar__list-item-cell"
                        >
                            {{ extra.name }}

                            <i
                                class="fa fa-info-circle fa-lg pointer"
                                style="padding-left: 1rem"
                                @click="showAdditionalInfo(resource, extra)"
                            />
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div
            ref="content"
            class="list-calendar__content"
        >
            <ul class="list-calendar__content-header">
                <li
                    class="list-calendar__content-header-item"
                    :class="day.class"
                    :key="`day-${day.number}`"
                    v-for="day in days"
                >

                    <p>{{ day.weekday }}</p>
                    <p>{{ `${day.number}. ${day.month}` }}</p>
                </li>
            </ul>

            <template v-if="dataPrepared">
                <ul
                    :key="`list-${resource[0].id}`"
                    v-for="resource in resources"
                    v-show="filteredResourceExtras[resource[0].id].length > 0 && onlyActiveVisible(resource)"
                    class="list-calendar__content-body-list"
                    :style="{
                        height: calculatedHeight[resource[0].id],
                    }"
                >
                    <li
                        :key="`day-cell-${day.number}`"
                        v-for="day in days"
                        class="list-calendar__content-body-list-item"
                        :class="{ 'list-calendar__content-body-list-item--is-hidden': calculatedHeight[resource[0].id] === heightPerLineString }"
                        :set="dayPrice = dayPrices[resource[0].id][`${currentYear}-${currentMonth}-${('0' + day.number).slice(-2)}`]"

                    >
                        <div
                            v-if="dayPrice"
                            class="list-calendar__list-item-cell"
                        >
                            <span
                                class="list-calendar__content-body-list-item--badge pointer"
                                v-if="dayPrice && dayPrice.value !== undefined && dayPrice.value !== null"
                                :class="dayPrice.classes"
                                @click="setResource(resource, day, day)"
                            >
                                {{ dayPrice.value.toFixed(2).replace('.', ',') }}
                            </span>
                            <span
                                class="list-calendar__content-body-list-item--badge pointer"
                                style="background-color: firebrick"
                                @click="setResource(resource, day, day)"
                                v-else>
                                n/a
                            </span>
                        </div>

                        <ul class="list-calendar__list-item-extras">
                            <li
                                :key="`extra-${extra.name}`"
                                v-for="extra in filteredResourceExtras[resource[0].id]"
                                class="list-calendar__list-item-cell"
                                data-set="dayPrice = dayPrices[extra.id][`${currentYear}-${currentMonth}-${('0' + day.number).slice(-2)}`]"
                                :set="dayPrice = getDayPriceInfo(extra, day)"

                            >
                                <template v-if="dayPrice && dayPrice.value !== null && dayPrice.value !== undefined">
                                    <span
                                        v-if="dayPrice.type === 'int' || dayPrice.type === 'price'"
                                        class="list-calendar__content-body-list-item--badge-secondary list-calendar__content-body-list-item--badge"
                                        :class="dayPrice.classes"
                                    >
                                        {{ dayPrice.type === 'price' ? dayPrice.value.toFixed(2).replace('.', ',') : dayPrice.value }}
                                    </span>
                                    <span
                                        v-if="dayPrice.type === 'choices' && dayPrice.value"
                                        class="list-calendar__content-body-list-item--badge-secondary list-calendar__content-body-list-item--badge res-item-cancellation-term"
                                        :class="dayPrice.classes"
                                        :title="getCancellationText(dayPrice.value)"
                                    >
                                        {{ dayPrice.value }}
                                    </span>
                                    <span
                                        v-if="dayPrice.type === 'bool'"
                                        class="list-calendar__content-body-list-item--is-icon"
                                    >
                                        <i
                                            v-if="dayPrice.value === true"
                                            class="fa fa-check-circle is-valid"
                                            aria-hidden="true"
                                            @click="setBool(extra, day, false)"

                                        />
                                        <i
                                            v-else
                                            class="fa fa-minus-circle is-invalid"
                                            aria-hidden="true"
                                            @click="setBool(extra, day, true)"
                                        />
                                    </span>
                                </template>
                            </li>
                        </ul>
                    </li>
                </ul>
            </template>
        </div>

        <Modal
            ref="modal"
            title="Info & Aufstellung"
        >
            <div v-if="currentResource && currentResource.html_info">
                <p v-html="currentResource.html_info"></p>
                <hr v-if="modalCurrentHtmlInfo && currentResource.show_table">
            </div>

            <div v-if="currentResource && currentResource.pricelist_range">
                <p>Preisliste verfügbar von {{getFormattedDate(currentResource.pricelist_range.min, 'dd L') }} bis {{ getFormattedDate(currentResource.pricelist_range.max, 'dd L') }}
                    (für {{ currentResource.pricelist_range.days_from_now }} Tage von heute an.)</p>
                <hr>
            </div>

            <table v-if="modalCurrentHtmlInfo && currentResource.show_table" style="min-width: 350px">
                <tr>
                    <th>{{modalCurrentHtmlInfo.header[0]}}</th>
                    <th>{{modalCurrentHtmlInfo.header[1]}}</th>
                    <th>{{modalCurrentHtmlInfo.header[2]}}</th>
                    <th style="text-align: right">{{modalCurrentHtmlInfo.header[3]}}</th>
                </tr>
                <tr v-for="row in modalCurrentHtmlInfo.table" :class="getRowClass(currentResource, row.price)">
                    <td v-if="!row.date_to" colspan="2">{{row.date_from}}</td>
                    <td v-if="row.date_to">{{getFormattedDate(row.date_from, 'dd, L')}}</td>
                    <td v-if="row.date_to">{{getFormattedDate(row.date_to, 'dd, L' )}}</td>
                    <td>{{row.duration}}</td>

                    <td style="text-align: right" v-if="currentResource.input_type==='price'">{{row.price.toFixed(2).replace('.', ',')}}</td>
                    <td style="text-align: center" v-if="currentResource.input_type==='bool'">
                    <i
                        v-if="row.value === true"
                        class="fa fa-check-circle is-valid"
                        aria-hidden="true"
                    />
                    <i
                        v-else
                        class="fa fa-minus-circle is-invalid"
                        aria-hidden="true"
                    />
                    </td>
                    <td style="text-align: right" v-else>{{row.value }}</td>
                    <td>
                      <i v-if="!currentResource.readonly && row.date_to && row.date_from"
                        @click="setResource(currentCampsiteResource, row.date_from, row.date_to)"
                        class="fa fa-pencil"
                        style="margin-left: 1rem"
                        aria-hidden="true"
                    />
                    </td>
                </tr>
            </table>
        </Modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VCalendar from 'v-calendar';
    import moment from 'moment';
    import { Api } from '../../../api';
    import { Modal } from '../../components';
    import api from '../../../api/Api';
    import {AppModel} from '../../../models';
    Vue.use(VCalendar);

    export default {
        name: 'list-calendar',
        components: {
            Modal
        },

        props: {
            filter: {
                type: String || null,
                default: null,
            },
            resources: {
                type: Array,
                default: [],
            },
            campsites: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {
                showFirstHalfOfMonth: true,
                minDate: new Date(moment().subtract(2, 'months').valueOf()),
                maxDate: new Date(moment().add(18, 'months').valueOf()),
                offsetPadding: 0,
                dataPrepared: false,
                heightPerLine: 2.5,
                heightPerLineString: '2.5rem',
                selectedMonth: null,
                showExtras: [],
                dayPrices: {},
                resourceExtras: {},
                calculatedHeight: {},
                modalCurrentHtmlInfo: '',
                currentResource: null,
                focusId: null,
                currentCampsiteResource: null,
                lang: AppModel.lang,
                filter_only_active: false
            };
        },
        watch: {
            filteredResourceExtras(resourceExtras) {
                if(typeof this.filter === 'string') {
                    Object.keys(resourceExtras).forEach((key) => {
                        this.adjustExtrasHeight(key);
                    });
                }

                this.$emit('calendar-loaded', this.resourceExtras);
            },
            async selectedMonth() {
                const preservedScrollPosition = this.$refs.content.scrollTop;

                await this.fetchData();

                this.$nextTick(() => {
                    const content = this.$refs.content;

                    this.offsetPadding = `${(content.offsetHeight - content.clientHeight)}px`;
                });

                this.$nextTick(() => {
                    this.$refs.content.scrollTop = preservedScrollPosition;
                });
            },
        },
        mounted() {
            const now = moment();

            this.$refs.content.addEventListener('scroll', (event) => {
                this.$refs.list.scrollTop = event.target.scrollTop;
            });
            this.$refs.list.addEventListener('scroll', (event) => {
                this.$refs.content.scrollTop = event.target.scrollTop;
            });

            this.showFirstHalfOfMonth = now.get('date') <= this.halfAmountOfDays;
        },
        computed: {
            halfAmountOfDays() {
                return Math.floor(this.daysInMonth / 2);
            },
            currentYear() {
                return this.selectedMonth.year;
            },
            currentMonth() {
                return ('0' + this.selectedMonth.month).slice(-2);
            },
            daysInMonth() {
                const now = this.getDateForDay(1);

                return now.daysInMonth();
            },
            days() {
                if(!this.selectedMonth) {
                    return [];
                }
                const zeroPad = (num) => String(num).padStart(2, '0');
                const lockTimes = AppModel.activeCampground.lock_times;

                const days = [];
                const daysAmount = this.showFirstHalfOfMonth ? this.halfAmountOfDays : this.daysInMonth;
                let i = this.showFirstHalfOfMonth ? 1 : this.halfAmountOfDays + 1;

                for(i; i <= daysAmount; i++) {
                    const currentDay = this.getDateForDay(i);
                    let closedOrNot = '';
                    let dateKey = `${this.currentYear}-${this.currentMonth}-${zeroPad(i)}`;
                    if(lockTimes) {
                        for(let lt in lockTimes) {
                            const lockTime = lockTimes[lt];
                            if(dateKey >= lockTime.locked_from && dateKey <= lockTime.locked_to) {
                                closedOrNot = 'closed';
                                break;
                            }
                        }
                    }
                    days.push({
                        number: i,
                        weekday: currentDay.format('ddd'),
                        month: currentDay.format('MMM'),
                        date: currentDay.toDate(),
                        class: closedOrNot,
                    });
                }

                return days;
            },
            dayRangeLabel() {
                return this.showFirstHalfOfMonth
                    ? `1. - ${this.halfAmountOfDays}.`
                    : `${this.halfAmountOfDays + 1}. - ${this.daysInMonth}.`;
            },
            filteredResourceExtras() {
                let filteredResourceExtras = {};

                if(this.filter && this.filter.trim()) {
                    Object.keys(this.resourceExtras).forEach((key) => {
                        filteredResourceExtras[key] = this.resourceExtras[key].filter((extra) => {
                            return extra.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                        });
                    });
                } else {
                    filteredResourceExtras = { ...this.resourceExtras };
                }

                return filteredResourceExtras;
            },
        },
        methods: {
            getDayPriceInfo(extra, day) {
                let value = null;
                if(day && this.dayPrices && this.dayPrices[extra.id]) {
                    try {
                        value = this.dayPrices[extra.id][`${this.currentYear}-${this.currentMonth}-${('0' + day.number).slice(-2)}`];
                    } catch (e) {
                        console.warn('getDayPriceInfo', e, this.dayPrices[extra.id]);
                    }
                }
                return value;
            },
            getCancellationText(cancellationId) {
                let result = '';
                AppModel.activeCampground.cancellation_terms.forEach(item => {
                    if(item.pms_key === cancellationId) {
                        result = item.name;
                        return result;
                    }
                });
                return result;
            },
            async fetchData() {
                const startDate = `${this.currentYear}-${this.currentMonth}-01`;
                const endDate = `${this.currentYear}-${this.currentMonth}-${this.daysInMonth}`;
                const promises = [];

                this.dataPrepared = false;
                this.resources.forEach((resource) => {
                    const id = resource[0].id.split(':').pop();
                    promises.push(Api.dayPrices.getDayPrices(id, startDate, endDate));
                });

                await Promise.all(promises).then((values) => {
                    const dayPrices = {};
                    const rawPrices = [];

                    values.forEach(({ data }) => {
                        rawPrices.push(data);
                    });

                    rawPrices.forEach((priceData) => {
                        priceData.data.forEach((price) => {
                            if(!dayPrices.hasOwnProperty(price.resource)) {
                                dayPrices[price.resource] = {};
                            }

                            dayPrices[price.resource][price.day] = {
                                type: null,
                                value: price.price || price.value,
                                classes: null,
                                class: price.class,
                            };
                        });
                    });

                    this.dayPrices = dayPrices;
                    this.prepareData();
                    this.preparePrices();
                    this.prepareBadgeClasses();
                    this.dataPrepared = true;
                });
            },
            getDateForDay(dayNum) {
                const day = ('0' + dayNum).slice(-2);

                return moment(`${this.currentYear}-${this.currentMonth}-${day}`);
            },
            monthChanged(month) {
                this.selectedMonth = month;
            },
            prepareData() {
                const resourceExtras = {};

                this.resources.forEach((resource) => {
                    const id = resource[0].id;

                    resourceExtras[id] = resource.slice(1);

                    if(!this.calculatedHeight[id]) {
                        this.$set(this.calculatedHeight, `${id}`, this.heightPerLineString);
                    }
                });

                this.resourceExtras = resourceExtras;
            },
            async setBool(resource, day, flag) {
                const zeroPad = (num, places) => String(num).padStart(places, '0');
                let dateKey = `${this.currentYear}-${this.currentMonth}-${zeroPad(day.number)}`;
                let data = [{'resource': resource.id, 'value': flag}];
                let campsite = resource.id.split(':').pop().split('_')[0];
                /*
                    {'campsite': '283',
                    'data': [{'resource': 'C:283_can_arrive', 'value': 'true'}],
                    'end': '2023-05-29',
                    'start': '2023-05-29'}
                * */
                const response = await Api.dayPrices.setDayPrices({
                    'campsite': campsite,
                    'start': dateKey,
                    'end': dateKey,
                    'data': data});
                if(response.status === 200) {
                    this.dayPrices[resource.id][dateKey].value = flag;
                }
            },
            preparePrices() {
                for(const dayPriceKey in this.dayPrices) {
                    const extras = this.resourceExtras[dayPriceKey];

                    if(extras) {
                        for(const parentPrice in this.dayPrices[dayPriceKey]) {
                            this.dayPrices[dayPriceKey][parentPrice].type = 'price';
                        }

                        for(const extra of extras) {
                            for(const extraPrice in this.dayPrices[extra.id]) {
                                this.dayPrices[extra.id][extraPrice].type = extra.input_type;
                            }
                        }
                    }
                }
            },
            prepareBadgeClasses() {
                for(const dayPriceKey in this.dayPrices) {
                    const dayPrices = this.dayPrices[dayPriceKey];
                    const keys = Object.keys(dayPrices);
                    let itemType = 'c';
                    if(dayPriceKey.indexOf(';') > 0) {
                        const words = dayPriceKey.split(';');
                        itemType = words[1].charAt(0).toLowerCase();
                    }

                    for(let i = 0; i < keys.length; i++) {
                        const currentDay = keys[i];
                        const previousDay = keys[i - 1];
                        const nextDay = keys[i + 1];
                        const currentDayPrice = dayPrices[currentDay];
                        const previousDayPrice = dayPrices[previousDay];
                        const nextDayPrice = dayPrices[nextDay];
                        const classes = [];
                        let resItemClass = '';

                        if(!previousDayPrice || previousDayPrice.value !== currentDayPrice.value) {
                            classes.push('list-calendar__content-body-list-item--badge-start');
                        }

                        if(!nextDayPrice || nextDayPrice.value !== currentDayPrice.value) {
                            classes.push('list-calendar__content-body-list-item--badge-end');
                        }

                        if(currentDayPrice.class) {
                            resItemClass += currentDayPrice.class;
                        }

                        classes.push(`list-calendar__content-body-list-item--badge-type-${itemType} ${resItemClass}`);
                        currentDayPrice.classes = classes;
                    }
                }
            },
            adjustExtrasHeight(resourceId) {
                const extras = this.filteredResourceExtras[resourceId];

                this.$set(
                    this.calculatedHeight,
                    `${resourceId}`,
                    (extras.length + 1) * this.heightPerLine + 'rem',
                );
            },
            toggleExtras(resourceId) {
                const height = this.calculatedHeight[resourceId];

                if(height === this.heightPerLineString) {
                    this.adjustExtrasHeight(resourceId);
                } else {
                    this.$set(
                        this.calculatedHeight,
                        `${resourceId}`,
                        this.heightPerLine + 'rem',
                    );
                }
            },
            setResource(resource, startDate, endDate) {
                if(typeof (startDate) === 'string') {
                    startDate = new Date(startDate);
                    endDate = new Date(endDate);
                    this.$refs.modal.show = false; /* would be better to make a refresh here after changes are made */
                } else {
                    if(startDate) {
                        startDate = startDate.date;
                        endDate = endDate.date;
                    }
                }
                if(startDate) {
                    this.$emit('resource-changed', resource, startDate, endDate);
                } else {
                    this.$emit('resource-changed', resource, new Date(), new Date());
                }

                setTimeout(() => {
                    if(this.focusId) {
                        document.getElementById(this.focusId).focus();
                    }
                }, 250);
            },
            moveCalendar(event, direction) {
                if(direction === 'next') {
                    if(this.showFirstHalfOfMonth) {
                        event.stopPropagation();
                        this.showFirstHalfOfMonth = false;
                    } else {
                        this.showFirstHalfOfMonth = true;
                    }
                } else if(direction === 'previous') {
                    if(!this.showFirstHalfOfMonth) {
                        event.stopPropagation();
                        this.showFirstHalfOfMonth = true;
                    } else {
                        this.showFirstHalfOfMonth = false;
                    }
                }
            },
            showAdditionalInfo(campsiteResource, resource) {
                this.focusId = resource.id;
                this.currentCampsiteResource = campsiteResource;
                this.currentResource = resource;
                if(!resource.show_table) {
                    this.modalCurrentHtmlInfo = null; // resource.html_info;
                    this.$refs.modal.show = true;
                } else {
                    api.dayPrices.getDayPricesTable(resource.id).then(response => {
                        this.modalCurrentHtmlInfo = response.data; // resource.html_info;
                        this.$refs.modal.show = true;
                    });
                }
            },
            getFormattedDate(date, format) {
                if(format) {
                    return moment(date).format(format);
                }
                return moment(date).format('L');
            },
            collapseAll() {
                let isAllCollapsed = true;

                Object.keys(this.calculatedHeight).forEach((key) => {
                    if(this.calculatedHeight[key] !== this.heightPerLineString) {
                        isAllCollapsed = false;
                    }
                });

                Object.keys(this.filteredResourceExtras).forEach((key) => {
                    if(isAllCollapsed) {
                        this.adjustExtrasHeight(key);
                    } else {
                        this.$set(
                            this.calculatedHeight,
                            `${key}`,
                            this.heightPerLine + 'rem',
                        );
                    }
                });
            },
            getRowClass(resource, price) {
                if(resource.input_type === 'price' && !price) {
                    return 'empty_price';
                }
                return '';
            },
            onlyActiveVisible(resource) {
                return (!this.filter_only_active || resource[0].active);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import './list-calendar';
   .res-item-quantity {
       background-color: #2aa198;
       color: white;
    }

    .res-item-red {
      background-color: red;
    }

    .res-item-orange {
      background-color: darkorange;
    }

    .r_default_ct {
      opacity: 66%;
    }

    .res-item-cancellation-term {
        background-color: lightsalmon;
    }
    .closed {
        background-color: darkred;
        color: white;
    }
    .empty_price {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/views/components/list-calendar/list-calendar.vue